// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Devices from "@material-ui/icons/Devices"; // Updated icon
import Assignment from "@material-ui/icons/Assignment"; // Updated icon
import AccountCircle from "@material-ui/icons/AccountCircle"; // Updated icon
import Info from "@material-ui/icons/Info"; // Updated icon
import BarChart from "@material-ui/icons/BarChart"; // Updated icon
import ShowChart from "@material-ui/icons/ShowChart"; // Updated icon
import MyLocation from "@material-ui/icons/MyLocation";
// import Chat from "@material-ui/icons/Chat";
// import ContentPaste from "@material-ui/icons/ContentPaste";
// core components/views
import DashboardPage from "views/Dashboard/Dashboard.jsx";
import DevicesPage from "views/Devices/Devices.jsx";
import DeviceDetailsPage from "views/DeviceDetails/DeviceDetails.jsx";
import DeviceReportsPage from "views/DeviceReports/DeviceReports.jsx";
import UserProfile from "views/UserProfile/UserProfile.jsx";
// import QuizList from "views/QuizListing/QuizListing.jsx";
// import QuizResults from "views/QuizResults/QuizResults.jsx";
// import ChatPage from "views/ChatPage/ChatPage.jsx";
// import CalendarPage from "views/Calendar/Calendar.jsx";
// import LibraryPage from "views/Library/Library.jsx";
// import AppointmentPage from "views/BookAppointment/BookAppointment.jsx";
import PlanPage from "views/PlanUser/Plan.jsx";
// import QuizResponseUser from "views/QuizResponseUser/QuizResponseUser.jsx";
import AssetsPage from "views/Assets/Assets.jsx";
import AssetDetailsPage from "views/AssetDetails/AssetDetails.jsx";
import AssetMapPage from "views/AssetMap/AssetMap.jsx";
import AssetBindingsPage from "views/AssetBindings/AssetBindings.jsx";

import { withAxios } from "containers/authenticated.js";
import AdvancedCharts from "../views/AdvancedCharts/AdvancedCharts";

const dashboardRoutes = [
  {
    path: "/dashboard",
    sidebarName: "Dashboard",
    navbarName: "Dashboard",
    icon: Dashboard,
    component: withAxios(DashboardPage),
  },
  {
    path: "/mydevices",
    sidebarName: "My Devices",
    navbarName: "My Devices",
    icon: Devices, // Updated icon
    component: withAxios(DevicesPage),
  },
  {
    path: "/asset-bindings",
    sidebarName: "Asset Bindings",
    navbarName: "Asset Bindings",
    icon: Assignment,
    component: withAxios(AssetBindingsPage),
  },
  {
    path: "/assets/map",
    sidebarName: "Asset Map",
    navbarName: "Asset Map",
    icon: MyLocation,
    component: withAxios(AssetMapPage),
  },
  {
    path: "/assets/:assetId",
    sidebarName: "Asset Details",
    navbarName: "Asset Details",
    icon: Info,
    component: withAxios(AssetDetailsPage),
    hide: true
  },
  {
    path: "/assets",
    sidebarName: "Assets",
    navbarName: "Assets",
    icon: Devices,
    component: withAxios(AssetsPage),
  },
  {
    path: "/myplan",
    sidebarName: "My Plan",
    navbarName: "My Plan",
    icon: Assignment, // Updated icon
    component: withAxios(PlanPage),
  },
  {
    path: "/user",
    sidebarName: "About Me",
    navbarName: "About Me",
    icon: AccountCircle, // Updated icon
    component: withAxios(UserProfile),
  },
  {
    path: "/devicedetails/:deviceId",
    sidebarName: "Device Details",
    navbarName: "Device Details",
    icon: Info, // Updated icon
    component: withAxios(DeviceDetailsPage),
    hide: true
  },
  {
    path: "/devicereports/:deviceId",
    sidebarName: "Device Reports",
    navbarName: "Device Reports",
    icon: BarChart, // Updated icon
    component: withAxios(DeviceReportsPage),
    hide: true
  },
  {
    path: "/data-charts/:deviceId",
    sidebarName: "Data Charts",
    navbarName: "Data Charts",
    icon: ShowChart, // Updated icon
    component: withAxios(AdvancedCharts),
    hide: false
  },
  // {
  //   path: "/mylivinglibrary",
  //   sidebarName: "My Living Library",
  //   navbarName: "My Living Library",
  //   icon: LocalLibrary,
  //   component: withAxios(LibraryPage)
  // },
  // {
  //   path: "/chat",
  //   sidebarName: "Chat",
  //   navbarName: "Chat",
  //   icon: Chat,
  //   component: withAxios(ChatPage)
  // },
  // {
  //   path: "/quizresponse/:quizName",
  //   sidebarName: "Quiz Responses",
  //   navbarName: "Quiz Responses",
  //   icon: QuestionAnswer,
  //   component: withAxios(QuizResponseUser),
  //   hidden: true
  // },
  // {
  //   path: "/quiz/:quizName",
  //   sidebarName: "Quiz",
  //   navbarName: "Quiz",
  //   icon: QuestionAnswer,
  //   component: withAxios(QuizList),
  //   hide: true
  // },
  // {
  //   path: "/results/:quizName",
  //   sidebarName: "Results",
  //   navbarName: "Results",
  //   icon: QuestionAnswer,
  //   component: withAxios(QuizResults),
  //   hide: true
  // },
  // {
  //   path: "/scheduleappointment",
  //   sidebarName: "Schedule Appointment",
  //   navbarName: "Schedule Appointment",
  //   icon: QuestionAnswer,
  //   component: withAxios(AppointmentPage),
  //   hide: true
  // },
  { redirect: true, path: "/", to: "/dashboard", navbarName: "Redirect" },
];

export default dashboardRoutes;
